import { useLocation } from 'wouter';
import { Receipt, Fuel } from 'lucide-react';

interface ExpenseButtonProps {
  allowExpenses: boolean;
  allowFuel: boolean;
}

export default function ExpenseButton({ allowExpenses, allowFuel }: ExpenseButtonProps) {
  const [, setLocation] = useLocation();

  if (!allowExpenses && !allowFuel) return null;

  return (
    <div className="grid grid-cols-2 gap-4">
      {allowExpenses && (
        <button
          onClick={() => setLocation('/expense')}
          className="flex flex-col items-center gap-2 p-6 bg-white rounded-xl shadow-sm border border-gray-100 active:bg-gray-50"
        >
          <div className="p-3 rounded-full bg-amber-100">
            <Receipt className="h-6 w-6 text-amber-600" />
          </div>
          <span className="font-medium text-gray-900">Registrar Despesa</span>
          <span className="text-xs text-gray-500">Reembolso</span>
        </button>
      )}

      {allowFuel && (
        <button
          onClick={() => setLocation('/fuel')}
          className="flex flex-col items-center gap-2 p-6 bg-white rounded-xl shadow-sm border border-gray-100 active:bg-gray-50"
        >
          <div className="p-3 rounded-full bg-emerald-100">
            <Fuel className="h-6 w-6 text-emerald-600" />
          </div>
          <span className="font-medium text-gray-900">Abastecimento</span>
          <span className="text-xs text-gray-500">Combustivel</span>
        </button>
      )}
    </div>
  );
}
